/**
 * Compteur messages Chat non lus (commerçant).
 * Source : GET /chat/commercant/:id/conversations → sum(unreadCount)
 * Semantics : messages CLIENT avec lu=false (actionnables).
 * Pas de polling agressif : fetch initial + event + interval soft 60s.
 */
import { useCallback, useEffect, useState } from 'react';
import apiService from '../services/api';
import { sumChatUnread } from '../utils/sumChatUnread';

export const CHAT_UNREAD_REFRESH_EVENT = 'clickorico:refresh-chat-unread-count';
export { sumChatUnread };

export function useChatUnreadCount(commercantId, enabled = true) {
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnread = useCallback(async () => {
    if (!enabled || !commercantId) {
      setUnreadCount(0);
      return;
    }
    try {
      const response = await apiService.getChatConversations(commercantId);
      const data = response?.data || response;
      const conversations = Array.isArray(data?.conversations)
        ? data.conversations
        : (Array.isArray(data) ? data : []);
      setUnreadCount(sumChatUnread(conversations));
    } catch {
      // Chat désactivé / 403 / erreur réseau → pas de badge trompeur
      setUnreadCount(0);
    }
  }, [commercantId, enabled]);

  useEffect(() => {
    if (!enabled || !commercantId) {
      setUnreadCount(0);
      return undefined;
    }
    fetchUnread();
    const onRefresh = () => fetchUnread();
    window.addEventListener(CHAT_UNREAD_REFRESH_EVENT, onRefresh);
    const interval = setInterval(fetchUnread, 60000);
    return () => {
      window.removeEventListener(CHAT_UNREAD_REFRESH_EVENT, onRefresh);
      clearInterval(interval);
    };
  }, [commercantId, enabled, fetchUnread]);

  return { unreadCount, refresh: fetchUnread };
}

export default useChatUnreadCount;
